import React, {useEffect} from 'react';

import '../../App.css';
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Status} from "../../feature/project/status";
import {ViewMode} from "../common/ViewMode";
import {fetchChapters} from "../../feature/project/chapterSlice";
import {List, NumericList} from "../common/ListItems";

const Chapters = (props: {}) => {

    const dispatch = useAppDispatch()
    const {projectId, actId, storyId} = useParams();
    const chapters = useAppSelector(state => state.chapters.chapters)
    const status = useAppSelector(state => state.chapters.status)

    useEffect(() => {
        if (status === Status.Idle && projectId && actId) {
            dispatch(fetchChapters({projectId: parseInt(projectId), actId: parseInt(actId)}))
        }
    }, [status, dispatch])

    return (
        <NumericList
            items={chapters}
            path={(id) => `/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${id}`}
        />
    );
};

export default Chapters;